import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Ano from '../../../../components/auth/balanco/listar/form_ano'


function AnoBalancoScreen() {

    return (
        <Fragment>
            <Head titulo="Editando ano do Balanço - Módulo de Balanços" />
            <HeaderLogged />
            <Container>
               <Ano />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default AnoBalancoScreen;